import { Suspense } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/components.tsx
var Lazy = ({ children, fallback }) => /* @__PURE__ */ jsx(Suspense, {
	fallback,
	children
});
var Conditional = ({ children, condition }) => condition ? children : null;
//#endregion
export { Conditional, Lazy };

//# sourceMappingURL=components.js.map